import IState from '@/interfaces/IState';
import axios from 'axios';
import {ActionContext} from 'vuex';

export default (context: ActionContext<IState, IState>, osName: string) => {
    try {
        const host = window.location.origin;
        const url = `${host}/desktopApp/${osName}/Switcherry-Admin-App[${osName}].zip/`;

        axios.get(url).then(
            response => {
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // // the filename you want
                a.download = `Switcherry-Admin-App[${osName}].zip`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);

                // alert('Your Desktop App has downloaded!');
                context.commit('uploadDownloadAppStatus', true)
            }
        )
    } catch (err) {
        throw new Error(err);
    }
};